module.exports = __webpack_public_path__ + "static/img/icon-btn-upload-business.d1d43a0b.png";